import util from 'util';
import child from 'child_process';
import fs from 'fs';
import * as R from 'ramda';

const exec = util.promisify(child.exec);

interface AppSyncError {
  message: string;
  errorType: string;
  data: object;
  errorInfo: object;
}
interface AppSync {
  result: object;
  error: AppSyncError;
  errors: AppSyncError[];
}

type SafeAppSync = Omit<AppSync, 'result'> & Record<'result', string>;

const getError = R.applySpec<AppSyncError>({
  message: R.prop('message'),
  errorType: R.prop('errorType'),
  data: R.prop('data'),
  errorInfo: R.prop('errorInfo')
});

const getResult = R.applySpec<AppSync>({
  result: R.compose<[SafeAppSync], string, object>(JSON.parse, R.prop('result')),
  error: R.compose(
    R.when(R.is(Object), getError),
    R.prop('error')
  ),
  errors: R.compose<[SafeAppSync], AppSyncError[], AppSyncError[]>(
    R.map(getError),
    R.prop('errors')
  )
});

const makeSafeForBinary = (str: string) => str.replace(/(["'$`\\])/g,'\\$1');

const defaultContext = {
  arguments: {},
  source: {},
  identity: {},
  request: {},
  info: {},
  stash: {},
  result: {},
  prev: {
    result: {},
  },
};

export async function render(fileName: string, inputContext: object = defaultContext): Promise<AppSync> {
  const binary = `${__dirname}/bridge`;

  const main = require.main as Record<'path', string>;

  const template = fs.readFileSync(`${main.path}/${fileName}`).toString();

  const context = { ...defaultContext, ...inputContext };

  const currentTime = new Date().toISOString();

  const state = { authType: 'User Pool Authentication', currentTime };

  const safeTemplate = makeSafeForBinary(template);
  const safeContext = makeSafeForBinary(JSON.stringify(context));
  const safeState = makeSafeForBinary(JSON.stringify(state));

  const command = `${binary} "${safeTemplate}" "${safeContext}" "${safeState}"`

  const { stderr, stdout } = await exec(command);

  if (stderr) {
    console.error(stderr);
  }

  const response: SafeAppSync = JSON.parse(stdout);

  try {
    return getResult(response);
  } catch (error) {
    console.error('Invalid JSON from template ' + fileName, '\n\n', response.result);
    throw error;
  }
}
